import { HttpClient, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, resource } from '@angular/core';
import { combineLatest, lastValueFrom, map } from 'rxjs';
import { SyncResponse } from '../../models/inventory.models';
import { LogsService } from '../logs/logs.service';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  http = inject(HttpClient);
  logs = inject(LogsService);

  dataSyncHistory$ = combineLatest([
    this.logs.getLog$('AIZOracleInventorySync'),
    this.logs.getLog$('HylaOracleInventorySync'),
  ]).pipe(
    map(([aizLogs, hylaLogs]) =>
      [...aizLogs, ...hylaLogs].sort(
        (a, b) =>
          new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
      ),
    ),
  );

  dataSyncHistory = resource({
    loader: () => lastValueFrom(this.dataSyncHistory$),
  });

  noDataSyncHistory = computed(() => this.dataSyncHistory.status() === 'error');

  salesChannelSyncHistory$ = this.logs
    .getLog$('SalesChannelInventorySync')
    .pipe(
      map((logs) =>
        logs.sort(
          (a, b) =>
            new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
        ),
      ),
    );

  salesChannelSyncHistory = resource({
    loader: () => lastValueFrom(this.salesChannelSyncHistory$),
  });

  downloadInventory(wmsCode: string | null | undefined) {
    const params = new HttpParams().set('wmsCode', wmsCode || '');

    return this.http.get('Inventory/download', {
      params,
      responseType: 'blob',
      observe: 'response',
    });
  }

  syncInventoryForUser(
    wmsCode: string | null | undefined,
    salesChannelCode?: string | null,
  ) {
    let params = new HttpParams().set('wmsCode', wmsCode || '');

    if (salesChannelCode) {
      params = params.set('salesChannelCode', salesChannelCode);
    }

    return this.http.post<SyncResponse>('Inventory/sync', {}, { params });
  }
}
